import React, { useState } from 'react';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';

interface UndoControlProps {
  onUndo: () => void | Promise<void>;
}

export function UndoControl({ onUndo }: UndoControlProps) {
  const [undone, setUndone] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleUndo = async () => {
    setDisabled(true);
    try {
      await onUndo();
      setUndone(true);
    } catch {
      setDisabled(false);
    }
  };

  if (undone) {
    return (
      <Button
        className="border-success text-success pe-none"
        iconEnd={faCheck}
        render={<span />}
        size="sm"
        variant="outline"
      >
        Undone
      </Button>
    );
  }

  return (
    <Button
      disabled={disabled}
      size="sm"
      variant="outline"
      onClick={handleUndo}
    >
      Undo
    </Button>
  );
}
